<template>
  <div class="block" v-if="project != null && project.laboral_references.length > 0">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <h1>Referencias Registradas</h1>
            <hr/>
          </div>
          <div id="table_references">
            <div class="col-md-12">
              <div class="text-type-work"> {{ textTypeWork }} </div>
              <table class="table table-condensed" id="table-laboral-references">
                  <thead>
                      <tr>
                        <th>Empresa</th>
                        <th>Cargo</th>
                        <th>Inicio</th>
                        <th>Fin</th>
                        <th>Contacto</th>
                        <th>Observaciones</th>
                        <th>Whatsapp</th>
                        <th>Autoriza contacto</th>
                        <th>Califica desempeño</th>
                        <th>Referencia verificada</th>
                        <th>Calificación</th>
                        <th colspan="2">Acciones</th>
                      </tr>
                  </thead>
                  <tbody id="laboral_references" v-if="project.laboral_references.length > 0">
                    <tr v-for="laboral_reference in project.laboral_references" :key="laboral_reference.id">
                      <td> {{laboral_reference.company_name}} </td>
                      <td> {{laboral_reference.charge}} </td>
                      <td> {{laboral_reference.start_at}} </td>
                      <td> {{laboral_reference.leave_at}} </td>
                      <td> {{laboral_reference.contact_name}} </td>
                      <td><p>{{laboral_reference.observations}}</p></td>
                      <td>
                        <template v-if="laboral_reference.url_whatsapp != ''">
                          <a :href="laboral_reference.url_whatsapp" target="_blank">Link</a>
                        </template>
                        <template v-else>
                          No disponible
                        </template>
                      </td>
                      <td>
                        {{ laboral_reference.authorize_contact | trueOrNot }}
                      </td>
                      <td>
                        {{ laboral_reference.reference_not_qualify | trueOrNotQualify }}
                      </td>
                      <td>
                        {{ laboral_reference.verified_reference | trueOrNot }}
                      </td>
                      <td>
                        {{laboral_reference.qualification}}
                      </td>
                      <td>
                        <button @click.prevent="edit(laboral_reference)" class="btn btn-info">Editar</button>
                      </td>
                      <td>
                        <button @click.prevent="deleteLaboralReference(laboral_reference)" class="btn btn-danger">Eliminar</button>
                      </td>
                      <td>
                        <button type="button" id="" class="btn btn-info " data-toggle="modal" data-target="#modalLog" @click="eventable_logs = laboral_reference">
                          Logs Mensajes
                        </button>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  <modal-log :eventable="eventable_logs" />
  </div>

</template>

<script>
  import axios from 'axios';
  import ModalLog from './modal-log.vue'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['project', 'laboral_reference'])
    },
    data() {
      return {
        textTypeWork: '',
        eventable_logs: null
      }
    },
    components: {
      'modal-log': ModalLog
    },
    methods: {
      ...mapMutations(['changeProject', 'changeLaboralReference']),
      edit (laboral_reference) {
        laboral_reference.relation_type == "boss" ?
        laboral_reference.relation_type = 0 :
        laboral_reference.relation_type = 1
        this.changeLaboralReference(laboral_reference)
      },
      setCredentials (){
        axios.defaults.headers['x-csrf-token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      },
      async deleteLaboralReference(laboral_reference) {
        this.setCredentials()
        const request = await axios.delete(`/api/v1/laboral/${laboral_reference.id}`)
        if (request.status == 200) {
          this.changeProject(request.data.project)
        }
        console.log(request)
      },

      getMessageLogs(laboral_reference) {
        this.setCredentials()
        const request = axios.get(`/api/v1/laboral/${laboral_reference.id}/message_logs`)
        console.log(request)
      },
      setTextTypeWork() {
        if (this.project.type_work_experience === 1) {
          this.textTypeWork = 'El candidato indica: NO contar con experiencia laboral formal'
        }else if (this.project.type_work_experience === 2){
          this.textTypeWork = 'El candidato indica: Cuenta con una (1) experiencia laboral formal'
        }
      }
    },
    watch: {
      project: function () {
        this.setTextTypeWork()
      }
    },
    filters: {
      trueOrNot: function(value) {
        if (value) {
          return 'Si'
        } else if(value == false) {
          return 'No'
        }else {
          return ''
        }
      },
      trueOrNotQualify: function(value) {
        if (value) {
          return 'No'
        }
        else {
          return 'Si'
        }
      }
    }
  }
</script>

<style scoped>
.text-type-work{
  margin: 10px 5px;
  font-size: 22px;
}
</style>
